/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Dialog_Text_To_Audio_Short_Warning_DescInputs */

const en_dialog_text_to_audio_short_warning_desc = /** @type {(inputs: Dialog_Text_To_Audio_Short_Warning_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This document only contains ${i?.count} characters. Are you sure you want to create audio from so little text?`)
};

const es_dialog_text_to_audio_short_warning_desc = /** @type {(inputs: Dialog_Text_To_Audio_Short_Warning_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este documento solo contiene ${i?.count} caracteres. ¿Seguro que quieres crear audio con tan poco texto?`)
};

/**
* | output |
* | --- |
* | "This document only contains {count} characters. Are you sure you want to create audio from so little text?" |
*
* @param {Dialog_Text_To_Audio_Short_Warning_DescInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_short_warning_desc = /** @type {((inputs: Dialog_Text_To_Audio_Short_Warning_DescInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Short_Warning_DescInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_short_warning_desc(inputs)
	return en_dialog_text_to_audio_short_warning_desc(inputs)
});